export default "__VITE_ASSET__850b37b9__"